module.exports = __webpack_public_path__ + "static/img/business-people-meeting.13909dde.jpg";